<template>
  <div>
    <v-layout wrap>
      <v-flex xs12>
        <v-card width="100%" style="font-family: poppinsregular">
          <v-layout wrap pa-5 text-left>
            <v-flex xs12 sm2 pt-2>
              <img
                style="object-fit: contain; cursor: pointer"
                :src="mediaURL + product.photo"
                height="160px"
                width="160px"
                contain
              />
            </v-flex>
            <v-flex sm10 pt-1>
              <v-layout wrap fill-height>
                <v-flex xs12 md6 align-self-center>
                  <v-layout wrap>
                    <v-flex xs5>
                      <b>Name </b>
                    </v-flex>
                    <v-flex xs7>
                      {{ product.varientName }}
                    </v-flex>
                    <v-flex xs5>
                      <b>Price </b>
                    </v-flex>
                    <v-flex xs7>
                      {{ product.price }}
                    </v-flex>
                    <v-flex xs5>
                      <b>Discount</b>
                    </v-flex>
                    <v-flex xs7> {{ product.discount }} % </v-flex>
                    <v-flex xs5>
                      <b>Quantity </b>
                    </v-flex>
                    <v-flex xs7>
                      {{ product.quantity }} {{ product.quantityType }}
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 md6 align-self-center>
                  <v-layout wrap>
                    <v-flex xs5>
                      <b>Min Order Quantity :</b>
                    </v-flex>
                    <v-flex xs7>
                      {{ product.minimumOrderQuantity }}
                    </v-flex>
                    <v-flex xs5>
                      <b>Max Order Quantity :</b>
                    </v-flex>
                    <v-flex xs7>
                      {{ product.maxOrderQuantity }}
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <StockInfo :stock="variants" :pages="pages" @stepper="winStepper" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import StockInfo from "../stock/stockView";
export default {
  components: {
    StockInfo,
  },
  data() {
    return {
      product: [],
      variants: [],
      pages: 0,
      currentPage: 1,
    };
  },

  mounted() {
    this.getData();
  },

  watch: {
    currentPage() {
      this.getData();
    },
  },

  methods: {
    winStepper(item) {
      this.currentPage = item.currentPage;
    },

    getData() {
      this.appLoading = true;
      axios({
        url: "/grocery/product/stock/getall/list",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },

        data: {
          productId: this.$route.query.id,
          page: this.currentPage,
          limit: 6,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.product = response.data.product;
          this.variants = response.data.data;
          this.pages = Math.ceil(response.data.totalLength / 6);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>